import React, { useState, createContext, useRef } from 'react';
import { Redirect } from 'react-router-dom';
import { useLockBodyScroll, useToggle } from 'react-use';
import { useOnClickOutside } from '../utils/useOnClickOutside';

export const ComponentContext = createContext();

const ComponentProvider = ({ children }) => {
  const ref = useRef();
  const [toggleAccount, setToggleAccount] = useToggle(false);
  const [toggleSupport, setToggleSupport] = useToggle(false);
  const [toggleNotification, setToggleNotification] = useToggle(false);
  const [loading, setLoading] = useState(true);
  const [runPackage, setRunPackage] = useState(false);
  const [redirectToReferrer, setRedirectToReferrer] = useState(false);
  const [unexpectedError, setUnexpectedError] = useState(null);
  const [docModal, setDocModal] = useToggle(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [reload, setReload] = useState(0);

  useOnClickOutside(ref, () => setToggleAccount(false));
  useOnClickOutside(ref, () => setToggleNotification(false));

  const handleDocModal = () => {
    setDocModal(prevState => !prevState);
  };

  useLockBodyScroll(toggleAccount);
  useLockBodyScroll(toggleSupport);
  useLockBodyScroll(toggleNotification);
  useLockBodyScroll(docModal);

  const handleMenuOpen = () => {
    setMenuOpen(prevState => !prevState);
  };

  const handleToggleAccount = () => {
    setToggleAccount(!toggleAccount);
  };

  const redirectUser = link => {
    if (redirectToReferrer) {
      return <Redirect to={link} />;
    }
  };

  const handleToggleSupport = () => {
    setToggleSupport(!toggleSupport);
  };

  const handleToggleNotification = () => {
    setToggleNotification(!toggleNotification);
  };

  return (
    <ComponentContext.Provider
      value={{
        menuOpen,
        handleMenuOpen,
        toggleAccount,
        handleToggleAccount,
        redirectUser,
        setRedirectToReferrer,
        redirectToReferrer,
        handleToggleSupport,
        toggleSupport,
        docModal,
        handleDocModal,
        handleToggleNotification,
        toggleNotification,
        ref,
        setLoading,
        loading,
        setUnexpectedError,
        unexpectedError,
        runPackage,
        setRunPackage,
        reload,
        setReload
      }}
    >
      {children}
    </ComponentContext.Provider>
  );
};

export default ComponentProvider;
